angular.module("vgresiduos").controller("createDisposalFromCollectionRequestCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `gestao-solicitacoes/${$stateParams.id}/nova-destinacao`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.numeroEquipamento) {
				queries.push({ key: "equipmentNumber", value: $stateParams.numeroEquipamento });
			}
			return queries;
		}
	}
]);
